import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import { obtenerSedes, sedesPorInstitucionId } from "../../../Services/Rest";

function CreaDocumentacion() {
  const cookies = new Cookies();
  const [postFechaCorte, setPostFechaCorte] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [postNombre, setPostNombre] = useState([]);
  const [postSede, setPostSede] = useState([]);
  const [archivos, setArchivos] = useState(null);
  const subirArchivos = (e) => {
    setArchivos(e);
  };
  const insertarArchivos = async () => {
    const username = "BasicAuth@icontec.org"; // Replace with your actual username
    const password = "yQLzqmR7eZSuAmQZUqhY"; // Replace with your actual password

    const basicAuth = btoa(`${username}:${password}`);
    const authHeader = `Basic ${basicAuth}`;

    const f = new FormData();

    for (let index = 0; index < archivos.length; index++) {
      f.append("files", archivos[index]);
    }

    setLoading(true);

    try {
      const conSede = `https://suadesarrollo.azurewebsites.net/api/CargaAnexosAdjuntos?Nombre=${postNombre}&InstitucionId=${cookies.get(
        "institucionid",
      )}&FechaCorte=${postFechaCorte}&Sede=${postSede}`;
      const sinsede = `https://suadesarrollo.azurewebsites.net/api/CargaAnexosAdjuntos?Nombre=${postNombre}&InstitucionId=${cookies.get(
        "institucionid",
      )}&FechaCorte=${postFechaCorte}&Sede=No Aplica`;
      if (
        postNombre ==
        "3.Certificado de cumplimiento de las condiciones de habilitación de la Dirección Territorial de Salud con fecha de expedición y declaración de novedades si aplica"
      ) {
        var urlendpoint = conSede;
      }
      if (
        postNombre !=
        "3.Certificado de cumplimiento de las condiciones de habilitación de la Dirección Territorial de Salud con fecha de expedición y declaración de novedades si aplica"
      ) {
        var urlendpoint = sinsede;
      }

      const response = await axios.post(urlendpoint, f, {
        headers: {
          Authorization: authHeader,
          "Content-Type": "multipart/form-data",
        },
      });

      console.log(response.data);
      alert("Cargue con éxito!");
      window.location.reload("/");
    } catch (error) {
      console.log(error);
      window.alert("Error al cargar");
    }
  };

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerAnexos",
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
        window.alert("error al cargar");
      });
  }, [setList]);
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: sedesPorInstitucionId + cookies.get("institucionid"),
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
        window.alert("error al cargar");
      });
  }, [setList1]);
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Adjuntar Documento
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Declaracion"
      >
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Sube el documento
                </h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="file"
                          name="files"
                          multiple
                          onChange={(e) => subirArchivos(e.target.files)}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Año de corte ejemplo: 2024"
                          onChange={(e) => setPostFechaCorte(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <left>
                      <div className="text-left">
                        <div className="col-sm-12">
                          <select
                            className="btn btn-secondary "
                            id="solicitudid"
                            onChange={(e) => setPostNombre(e.target.value)}
                            required
                          >
                            <option value="">Seleccione el anexo</option>
                            {list.map((item) => (
                              <option value={item.nombre}>{item.nombre}</option>
                            ))}
                          </select>
                        </div>
                        <hr />
                        {postNombre ==
                        "3.Certificado de cumplimiento de las condiciones de habilitación de la Dirección Territorial de Salud con fecha de expedición y declaración de novedades si aplica" ? (
                          <div className="col-sm-12">
                            <select
                              className="btn btn-secondary btn-user btn-block text-left"
                              id="solicitudid"
                              onChange={(e) => setPostSede(e.target.value)}
                            >
                              <option value="">Seleccione la sede</option>
                              {list1.map((item) => (
                                <option value={item.nombre}>
                                  {item.nombre}
                                </option>
                              ))}
                            </select>
                          </div>
                        ) : (
                          <h1></h1>
                        )}
                      </div>
                    </left>
                  </table>
                  <hr />
                  <div className="col-sm-12">
                    <p>
                      {!isLoading && (
                        <button
                          className="btn btn-primary btn-user btn-block"
                          onClick={insertarArchivos}
                        >
                          {" "}
                          Guardar{" "}
                        </button>
                      )}
                      {isLoading && (
                        <button
                          type="submit"
                          name=""
                          className="btnContactSubmit btn-block"
                          disabled
                        >
                          <i className="btn btn-primary btn-user btn-block"></i>{" "}
                          Cargando...
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaDocumentacion;
